export let DuplexerChannel = /*#__PURE__*/function (DuplexerChannel) {
  DuplexerChannel["TASKS"] = "nownia-tasks";
  DuplexerChannel["ENRICHED_TASKS"] = "nownia-enriched-tasks";
  DuplexerChannel["ACTIONS"] = "nownia-actions";
  DuplexerChannel["ENRICHED_RECURRING_SCHEDULES"] = "recurring-schedules";
  return DuplexerChannel;
}({});
export let IndividualsDuplexerChannel = /*#__PURE__*/function (IndividualsDuplexerChannel) {
  IndividualsDuplexerChannel["DIGEST"] = "individuals-digest";
  IndividualsDuplexerChannel["ENRICHED_CONTEXT"] = "individuals-enriched-context";
  IndividualsDuplexerChannel["CONVERSATION"] = "individuals-conversation";
  IndividualsDuplexerChannel["RECIPIENT"] = "individuals-recipient";
  IndividualsDuplexerChannel["INSIGHT"] = "individuals-insight";
  IndividualsDuplexerChannel["ASSISTANT_CHAT"] = "individuals-assistant-chat";
  return IndividualsDuplexerChannel;
}({});
//# sourceMappingURL=Duplexer.js.map